"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageVariables = void 0;
/**
 * @Author: Dabson Ferreira
 * @Date:   2023-11-24 11:58:05
 */

const LocalStorageVariables = exports.LocalStorageVariables = {
  PageToken: 'token',
  InactivityTimer: 'inactivity_timer'
};